import React from "react";
import styled from "styled-components";
/* import BindeleddetStandardLogo from "../BindeleddetLogoComponents/BindeleddetStandardLogo/BindeleddetStandardLogo"; */
import kdLogoSmall from "kd/assets/KD_logo/kd_logo_small.png";
import kdLogoWhite from "kd/assets/KD_logo/kd_logo_small_white.png";
import { Link, useLocation } from "react-router-dom";
import BurgerKD from "./Burger_KD";

export const NAVBAR_HEIGHT = 65;

const Nav = styled.nav<{ pathname: string }>`
  width: 100%;
  height: ${NAVBAR_HEIGHT}px;
  padding: 0px 0px;
  display: flex;
  justify-content: space-between;
  background-color: ${props => (props.pathname === "/" ? null : "var(--neutral)")};
  position: ${props => (props.pathname === "/" ? "absolute" : "fixed")};
  box-shadow: ${props => (props.pathname === "/" ? "" : "0 2px 4px 0 rgba(0, 0, 0, 0.2)")};
  z-index: 140;
`;
/* const StyledBindeleddetStandardLogo = styled(BindeleddetStandardLogo)`
  height: 600px;
`;  */

const StyledImg = styled.img`
  height: 40px;

  @media only screen and (max-width: 768px) {
    height: 35px;
  }
  @media only screen and (max-width: 600px) {
    height: 30px;
  }
`;

const StyledImageWrapper = styled.div`
  padding: 12px 0;

  @media only screen and (max-width: 768px) {
    padding: 15px 0;
  }
  @media only screen and (max-width: 600px) {
    padding: 18px 0;
  }
`;

const NavbarKD = () => {
  const { pathname } = useLocation();
  return (
    <Nav pathname={pathname} style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
      <StyledImageWrapper>
        {/* <StyledBindeleddetStandardLogo height="40px" /> */}
        <Link to="/kd/">
          <StyledImg
            src={document.body.getAttribute("data-theme") === "dark" ? kdLogoWhite : kdLogoSmall}
            alt="KD small logo"
          />
        </Link>
      </StyledImageWrapper>
      <BurgerKD />
    </Nav>
  );
};

export default NavbarKD;
